<template>
  <el-dialog
    :title="mode === 'reset' ? `Schimbare parola pentru ${selectedObject.Nume}` : 'Schimbare parola'"
    append-to-body
    :visible.sync="showPopup"
    id="popup_dialog"
    class="my-dialog-class"
  >
    <el-form
      label-position="top"
      :inline="false"
      :rules="rules"
      label-width="100%"
      :model="selectedObject"
      ref="my-form"
      @submit.prevent="save"
    >
      <el-row :gutter="15" v-if="TipUser === 'Mecanic' || TipUser === 'AjutorMontator'">
        
        <el-col :md="8">
          <el-form-item prop="NewPassword" label="Pin nou">
            <el-input
              show-password
              class="full-width"
              v-model="selectedObject.NewPassword"
            />
          </el-form-item>
        </el-col>
        <el-col :md="8">
          <el-form-item prop="NewPassword2" label="Repeta pin-ul nou">
            <el-input
              show-password
              class="full-width"
              v-model="selectedObject.NewPassword2"
            />
          </el-form-item>
        </el-col>

      </el-row>
      <el-row :gutter="15" v-else>
        <el-col :md="8">
          <el-form-item prop="NewPassword" label="Parola noua">
            <el-input
              show-password
              class="full-width"
              v-model="selectedObject.NewPassword"
            />
          </el-form-item>
        </el-col>
        <el-col :md="8">
          <el-form-item prop="NewPassword2" label="Repeta parola noua">
            <el-input
              show-password
              class="full-width"
              v-model="selectedObject.NewPassword2"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="showPopup = false"> Renunta </el-button>
      <el-button type="primary" @click="save"> Salveaza </el-button>
    </span>
  </el-dialog>
</template>

<script>
import settings from "@/backend/LocalSettings";

export default {
  name: "ChangePassword_dialog",
  data() {
    var checkPass = (rule, value, callback) => {
      if (value == "" || value.length < 0) {
        callback(new Error("Campul este obligatoriu"));
      } else {
        if (TipUser === 'Mecanic' || TipUser === 'AjutorMontator') {
          let base = /^(?=.*[0-9])[0-9]{4,4}$/;
        if (!value.match(base)) {
          callback(
            new Error(
              "Pin-ul trebuie sa contina 4 cifre"
            )
          );
        } else {
          callback();
        }
        } else {
          let base = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9])[A-Za-z\d\W_]{8,32}$/;
        if (!value.match(base)) {
          callback(
            new Error(
              "Parola trebuie sa contina cel putin 8 caractere, o litera mare, o litera mica, o cifra si un caracter special"
            )
          );
        } else {
          callback();
        }
        }
      }
    };

    var checkPassMecanic = (rule, value, callback) => {
      // console.log(value)
      if (value == "" || value.length < 0) {
        callback(new Error("Campul este obligatoriu"));
      } else {
        let base = /^(?=.*[0-9]){4,4}$/;
        if (!value.match(base)) {
          callback(
            new Error(
              "Parola trebuie sa fie formata din 4 cifre"
            )
          );
        } else {
          callback();
        }
      }
    };

    var samePass = (rule, value, callback) => {
      if (value == "" || value.length < 0) {
        callback(new Error("Campul este obligatoriu"));
      } else {
        if (value !== this.selectedObject.NewPassword) {
          callback(new Error("Cele doua parole nu corespund"));
        } else {
          callback();
        }
      }
    };
    return {
      showPopup: false,
      mode: "",
      selectedObject: {
        NewPassword: "",
        NewPassword2: "",
      },
      Info: {},
      TipUser: '',
      rules: {
        NewPassword: [{ validator: this.checkPass, trigger: ["blur", "change"] }],
        NewPassword2: [{ validator: samePass, trigger: "change" }],
        
      },
    };
  },
  methods: {
    checkPass: function(rule, value, callback) {
      if (value == "" || value.length < 0) {
        callback(new Error("Campul este obligatoriu"));
      } else {
        if (this.TipUser === 'Mecanic' || this.TipUser === 'AjutorMontator') {
          let base = /^(?!\d*(\d)\1)\d{4}$/;
          if (!value.match(base)) {
            callback(
              new Error(
                "Pinul trebuie sa fie compus din 4 cifre, 2 cifre adiacente nu trebuie sa se repete"
              )
            );
          } else if(['0123', '1234', '2345', '3456', '4567', '5678', '7890', '0987', '9876', '8765', '7654', '6543', '5432', '4321'].includes(value) ) {
            callback(
              new Error(
                "Pinul trebuie sa fie un pic mai complex decat atat"
              )
            );
          } else {
            callback();
          }
        } else {
          let base = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9])[A-Za-z\d\W_]{8,32}$/;
        if (!value.match(base)) {
          callback(
            new Error(
              "Parola trebuie sa contina cel putin 8 caractere, o litera mare, o litera mica, o cifra si un caracter special"
            )
          );
        } else {
          callback();
        }
        }
      }
    },
    show_me: async function (user, mode) {
      this.showPopup = true;
      this.selectedObject.Email = user.Email;
      this.selectedObject.Id = user.Id;
      this.selectedObject.Nume = user.Nume;
      this.selectedObject.NewPassword = "";
      this.selectedObject.NewPassword2 = "";
      this.mode = mode;
      this.TipUser = user.TipUtilizator;
      // console.log(user, this.mode);
    },
    post: async function (url, args = {}) {
      this.loadingVisible = true;
      var response = await this.$http.post(url, args);
      this.loadingVisible = false;
      if (settings.verify_response(response)) {
        return response.body;
      } else {
        this.$router.push("/"); 
      }
    },
    save: async function () {
      this.$confirm("Suneti sigur ca doriti sa schimbati parola acestui utilizator", "Warning", {
        confirmButtonText: 'Continua',
        cancelButtonText: 'Renunta',
        type: 'warning'
      }).then(() => {
        this.$refs["my-form"].validate(async (valid) => {
        if (valid) {
          if (this.mode === 'reset') {
            //aici e cand un admin ii reseteaza parola
            // console.log(this.selectedObject)
            var response = await this.post('utilizatori/reset_password', {info: this.selectedObject});
            if (response.success === true) {
              this.$message({type: 'success', message: 'Parola a fost schimbata cu succes'});
              this.showPopup = false;
            } else if(response.HasError){
              this.$message({type: 'error', message:response.Error}); 
            } else {
              this.$message({type: 'error', message:'A intervenit o eroare in procesul schimbarii parolei'});
            }
          } else {
            //aici e pentru cand si-a uiat parola.
          }
        }
      });
      }).catch(() => {})
    },
  },
  mounted: function () {},
};
</script>

<style lang="less" scoped>
.full-width {
  width: 100%;
}
</style>

